import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isAdminRole, isTrueAdmin } from "@/lib/roles";

interface AdminGuardProps {
  children: ReactNode;
  trueAdminOnly?: boolean;
}

export default function AdminGuard({
  children,
  trueAdminOnly = false,
}: AdminGuardProps) {
  const { nhanVien, loading, profileLoading } = useAuth();

  // Chờ biết chức vụ rồi mới xét quyền, tránh đá nhầm người có quyền về /scan.
  // Nhưng nếu hồ sơ đã có sẵn thì KHÔNG làm trắng trang nữa — chỉ cần chờ ở
  // lần tải đầu tiên. Nhờ vậy việc gia hạn token ngầm không làm trang bị
  // "dựng lại từ đầu" mỗi phút một lần.
  if (loading) {
    return null;
  }

  if (profileLoading && !nhanVien) {
    return null;
  }

  const allowed = trueAdminOnly
    ? isTrueAdmin(nhanVien?.chuc_vu)
    : isAdminRole(nhanVien?.chuc_vu);

  if (!allowed) {
    return <Navigate to="/scan" replace />;
  }

  return <>{children}</>;
}